// RigSentinel Owner Dashboard V1 — additive, fire-and-forget product-usage
// telemetry. Wraps the existing trackBillingEvent() transport (same
// /api/analytics/track endpoint, same session-id/credentials handling).
// NEVER carries engineering values — only feature/report identifiers and
// category labels declared in the calculator/report catalogs.
import { trackBillingEvent } from "@/lib/billingClient";

const SESSION_FLAG_KEY = "rsc.telemetry.sessionStarted.v1";

// Fires once per browser tab session (sessionStorage-scoped, not per route).
export function trackAppSessionStarted() {
  try {
    if (sessionStorage.getItem(SESSION_FLAG_KEY)) return;
    sessionStorage.setItem(SESSION_FLAG_KEY, "1");
  } catch { /* ignore */ }
  trackBillingEvent("app_session_started");
}

export function trackFeatureOpened(featureId, featureCategory) {
  if (!featureId) return;
  trackBillingEvent("feature_opened", { featureId, featureCategory });
}

export function trackCalculatorAttempted(featureId, result) {
  if (!featureId) return;
  trackBillingEvent("calculator_calculate_attempted", { featureId, featureCategory: "calculator", result });
}

export function trackPremiumBlocked(featureId) {
  if (!featureId) return;
  trackBillingEvent("premium_result_blocked", { featureId, featureCategory: "calculator" });
}

export function trackUpgradeModalViewed(featureId, source) {
  trackBillingEvent("upgrade_modal_viewed", { featureId: featureId || null, source: source || null });
}

export function trackUpgradeCtaClicked(featureId, source) {
  trackBillingEvent("upgrade_cta_clicked", { featureId: featureId || null, source: source || null });
}
